import React, { Component } from 'react'
import BaseLayout from 'containers/BaseLayout'
import HeaderTitle from 'components/HeaderTitle'

import { gql } from 'apollo-boost'
import { Query, Mutation } from 'react-apollo'

import {
  Columns, Column, Box, Button, Title, Subtitle
} from 'bloomer'

import { Link, Redirect } from 'react-router-dom'
import { CURRENT_HOUSE_KEY } from '../../constants'

const GET_INVITATION = gql`
  query ($invitationId: UUID!) {
    invitation(invitationId: $invitationId) { id, email, accepted, house { name, description, owner { id, firstName }} },
    me { id, email }
  }
`

const ACCEPT_INVITATION = gql`
  mutation ($invitationId: UUID!) {
    acceptInvitation(invitationId: $invitationId) {
      invitation { id, accepted }
    }
  }
`

export default class InvitationPage extends Component {

  handleSelection = (update, houseId, evt) => {
    localStorage.setItem(CURRENT_HOUSE_KEY, houseId)
    update()
    this.setState(() => ({ready: true}))
  }

  handleModalOpen = () => {
    this.setState(() => ({
      isModalOpen: true
    }))
  }

  handleModalClose = () => {
    this.setState(() => ({
      isModalOpen: false
    }))
  }

  render() {
    const { match: {params: {invitationId}}} = this.props

    return (
      <Query query={GET_INVITATION} variables={{invitationId}}>
        {({data, loading, error}) => {
          if (loading) {
            return <p>Carregando...</p>
          }

          if (error || data.invitation.email !== data.me.email || data.invitation.accepted) {
            return <Redirect to="/" />
          }

          return (
            <BaseLayout title={() => <HeaderTitle>Convite</HeaderTitle>}>
              <Columns isCentered>
                <Column isSize={{mobile: 12, desktop: '1/2'}}>
                  <Mutation mutation={ACCEPT_INVITATION} variables={{invitationId}}>
                  {(mutate, {loading}) => (
                    <Box style={{textAlign: 'center'}}>
                      <Title isSize={4}>Desejar aceitar o convite de {data.invitation.house.owner.firstName}?</Title>
                      <Subtitle isSize={5}>Você ganhará acesso a casa <strong>{data.invitation.house.name}</strong>.</Subtitle>
                      <Button className="is-text" render={(props) => <Link to="/" {...props}/>}>Cancelar</Button>
                      <Button isColor="primary" onClick={mutate} isLoading={loading}>Aceitar</Button>
                    </Box>
                  )}
                  </Mutation>
                </Column>
              </Columns>
            </BaseLayout>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/InvitationPage/index.js